import { render, staticRenderFns } from "./PatDossierList.vue?vue&type=template&id=bd4bc276&scoped=true"
import script from "./PatDossierList.vue?vue&type=script&lang=js"
export * from "./PatDossierList.vue?vue&type=script&lang=js"
import style0 from "./PatDossierList.vue?vue&type=style&index=0&id=bd4bc276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4bc276",
  null
  
)

export default component.exports